<template>
  <el-dialog
    :model-value="isOpen"
    width="744px"
    @close="$emit('close')"
  >
    <h1 class="tw-mb-8">
      {{ $t('quest.add_questionnaire') }}
    </h1>
    <el-form
      ref="Form"
      :model="form"
      :rules="formRules"
      label-position="top"
      :disabled="isLoading"
      class="tw-flex tw-flex-col tw-gap-2 tw-mt-3"
      @submit.native.prevent="submitForm"
    >
      <el-form-item
        :label="$t('quest.quest_type')"
        prop="survey_type"
      >
        <el-select
          v-model="form.survey_type"
          placeholder=""
          filterable
          :filter-method="questionnairesFilterMethod"
          :visible-change="handleQuestionnairesVisibleChange"
        >
          <el-option
            v-for="item in filteredQuestionnaires"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-switch
          v-model="form.enable_notification"
          :active-text="$t('quest.notify')"
          class="tw-mt-1"
        />
      </el-form-item>
    </el-form>

    <template #footer>
      <div class="tw-flex tw-justify-end tw-gap-2 flex-col md:flex-row">
        <i-button
          class="tw-w-40"
          @click="$emit('close')"
        >
          {{ $t('common.actions.cancel') }}
        </i-button>
        <i-button
          type="primary"
          class="tw-w-40"
          :is-loading="isLoading"
          @click="submitForm"
        >
          {{ $t('common.actions.save') }}
        </i-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { questionnairesFilterMixin } from '@/mixins/questionnairesFilterMixin';
import { mapState } from 'vuex';

export default {
  mixins: [questionnairesFilterMixin],
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: false,
      form: {
        survey_type: '',
        enable_notification: false,
      },
      formRules: {
        survey_type: [
          { required: true, message: 'Type is empty', trigger: 'blur' },
        ],
      },
    };
  },

  computed: {
    ...mapState({
      foreigner: (state) => state.v2.admin.foreigners.foreigner.foreigner,
      questionnaires: (state) => state.v2.shared.enums.enums.survey_types, // TODO: not sorted,
    }),
  },

  methods: {
    async submitForm() {
      const isValid = await this.$refs.Form.validate().catch(() => false);
      if (!isValid) {
        return;
      }

      try {
        await this.$store.dispatch('v2/admin/foreigners/foreigner/addQuestionnaire', {
          foreignerId: this.foreigner.id,
          payload: this.form,
        });

        await this.$store.dispatch('v2/admin/foreigners/foreigner/loadQuestionnaires', this.foreigner.id);
      } catch (error) {
        this.$message.error({
          message: this.$capitalize(this.$t('core.error.internal_server_error')),
          showClose: true,
        });
      }

      this.$emit('close');
    },
  },
};
</script>
